













































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { filterEmpty } from '@acgn/herm/src/util/business';
import { AcgnTitle, AcgnAuditStep, AcgnUpload, AcgnPop } from '@acgn/herm/src/ui';
import { AttributeMixin, RenderMenuMixin } from '@/mixins';
import { AcgnFormContent, AcgnFormTitle, AcgnTaskMenu, AcgnGroupEdit, AcgnApprovalDetail } from '@/components/';
import { AcgnTaskAuditing, AcgnEditStatus } from './components/';
// import { AcgnApprovalDetail } from './components/task-auditing/components';
import { namespace } from 'vuex-class';
import { DatePicker } from 'element-ui';
import { complexClone } from '@acgn/herm/src/util/serialize';
import { getComicUploadImageSts } from '@/api/ossClient';
import { displayFormValidationError } from '@acgn/herm/src/util/form';
import { setDateTimeStamp, getDateTimeStamp } from '@acgn/herm/src/util/time';
import event from '@acgn/herm/src/util/event';

const TaskGroupAction = namespace('desk/taskGroup').Action;
const TaskGroupGetter = namespace('desk/taskGroup').Getter;

// 组件申明
@Component({
  components: {
    AcgnTitle,
    AcgnAuditStep,
    AcgnFormContent,
    AcgnFormTitle,
    AcgnTaskAuditing,
    AcgnUpload,
    AcgnPop,
    AcgnTaskMenu,
    AcgnGroupEdit,
    AcgnApprovalDetail,
    AcgnEditStatus,
    [DatePicker.name]: DatePicker
  },
  mixins: [AttributeMixin, RenderMenuMixin]
})

/**
 * 任务详情
 */
export default class ComicDetail extends Vue {
  @TaskGroupAction private getTaskDetail: any; // 获取任务组
  @TaskGroupGetter private loadings: any; // 章节loading

  private comicId: any = 0;
  private appro: any = false;
  private visible: any = false;
  private editItem: any = [];
  private task_id: any = 0;
  private comicMessage: any = {}; // 漫画信息
  private examineList: any = [];  // 审核列表
  private servicesTime: any = undefined;
  private manageGroupList: any = [
    {
      id: 1,
      name: '项目概况',
      icon: 'ift-project_2',
      url: 'desk-comicAuthDetail',
      belong: 'comicAuth',
      selected: false,
    }
  ]; // 选中的管理组
  private pickerOptions: any = {
    disabledDate(time: any) {
      return time.getTime() + 86400000 <= Date.now(); // 选当前时间之后的时间
    }
  };

  // 编辑逾期状态弹框
  private editStatasModel(...item: any) {
    this.editItem = item;
    this.visible = true;
  }

  // 渲染左侧菜单
  private renderMenu() {
    return (
      <acgn-task-menu authorityCode="1003" source="comic"
        hasTask={true}
        getProjectList={this.getProjectList} manageGroupList={this.manageGroupList}></acgn-task-menu>
    );
  }

  // 刷新列表
  private refreshApproList(data: any) {
    // this.comicMessage.linkName = data.name;
    // this.comicMessage.linkId = data.id;
    this.comicMessage = {
      ...this.comicMessage,
      linkName: data.name,
      linkId: data.id
    };
    this.appro = true;
  }

  // 获取表单验证规则
  private get rules() {
    const rules = {
      task_group_name: [
        { required: true, message: '请输入任务组名', trigger: 'blur' }
      ],
      task_name: [
        { required: true, message: '请输入任务名', trigger: 'blur' }
      ],
      dead_line: [
        { required: true, message: '请选择日期', trigger: 'blur' }
      ]
    };

    return rules;
  }

  private created() {
    this.comicId = this.$route.params.id;
    this.task_id = parseInt(this.$route.params.task_id, 10);
  }

  private getProjectList(data: any) {
    this.comicMessage = data;
    this.comicMessage.dead_line = setDateTimeStamp(this.comicMessage.dead_line, 'YYYY-MM-DD HH:mm:ss');
    this.refreshExamine();
  }
  // 刷新列表
  private async refreshExamine() {
    const {result, raw: {data: { servicesTime }}} = await this.getTaskDetail({ task_id: this.comicMessage.id});
    this.servicesTime = servicesTime;
    this.examineList = result;
  }

  // 获取状态
  private getStadius(row: any) {
    return (
      <span class="detail-sta">已过审</span>
    );
  }

  // 返回列表
  private goBack() {
    this.$router.back();
  }
}
